import projectStatsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';

export default createAsyncRequestReducer(
  projectStatsActionTypes.FETCH_PROJECT_STATS,
);
